import { render, staticRenderFns } from "./Notifications_TwitterMessage.vue?vue&type=template&id=5ae5de15&scoped=true&"
import script from "./Notifications_TwitterMessage.vue?vue&type=script&lang=js&"
export * from "./Notifications_TwitterMessage.vue?vue&type=script&lang=js&"
import style0 from "./Notifications_TwitterMessage.vue?vue&type=style&index=0&id=5ae5de15&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ae5de15",
  null
  
)

export default component.exports